import React, { useState } from 'react'
import Form from './form'

export default function (props) {
  const [data, setData] = useState({ use_camera: false, active: false })

  return <Form data={data} setData={setData} {...props} />
}
